import NewLessonForm from "./NewLessonForm"
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
function NewLesson() {
    useTitle('geshtop-Exercise: New Lesson')


    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    if (!groups?.length) return <PulseLoader color={"#FFF"} />
    const content = <NewLessonForm groups={groups} />
    return content

}

export default NewLesson